export const checkForForbiddenUser = res => {
    return res && res.ok === false && res.data && res.data.data && res.data.data.error === 'B2C-Forbidden-User';
};
